import { type FC } from "react";
import { type GetFamilyCustomerAddressesPagesSettingsShipmentQuery } from "@/pages/settings/shipment/__gql__/get-family-customer-address.gen";
import { UserInfo } from "@/components/fragments/userinfo";
import Link from "next/link";
import { pagesPath } from "@/pathpida/generated/$path";

interface Props {
  familyCustomerAddresses:
    | GetFamilyCustomerAddressesPagesSettingsShipmentQuery["familyCustomer"]["familyCustomerAddresses"]
    | undefined;
}

export const FamilyCustomerAddressLinkList: FC<Props> = ({ familyCustomerAddresses }) => (
  <>
    {familyCustomerAddresses?.map(({ uuid, address1, address2, buildingName, firstName, lastName, isPrimary }) => (
      <UserInfo
        key={uuid}
        as={Link}
        href={pagesPath.settings.shipment._shipmentId(uuid).info.$url()}
        w="100%"
        type="edit"
        user={{
          lastName: lastName ?? "",
          firstName: firstName ?? "",
          address: `${address1 ?? ""}${address2 ?? ""}${buildingName ?? ""}`,
        }}
        isSelect={isPrimary ?? false}
        data-testid={`pages/settings/shipment/__components__/FamilyCustomerAddressList-${uuid}`}
      />
    ))}
  </>
);
